import React from 'react'
import GAOrganizationsContainer from '../../modules/GAOrganizations/containers/GAOrganizationsContainer/GAOrganizationsContainer'

const GAOrganizations = () => {
  return (
    <GAOrganizationsContainer />
  )
}

export default GAOrganizations